import script from "./ChapterDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ChapterDetails.vue?vue&type=script&setup=true&lang=js"

import "./ChapterDetails.vue?vue&type=style&index=0&id=7dc63202&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc63202"]])

export default __exports__